import { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import { useMediaQuery } from '@mui/material';
import { ShopifyTransparentInstalled } from './ShopifyTransparentInstalled';
import { AddShopifyInstallButton } from './AddShopifyInstallButton';
import './styles.scss';
import { ShopifyTransparent } from './ShopifyTransparent';
import { ShopifyRedirect } from './ShopifyRedirect';
import { useTestModeHandler } from './useTestModeHandler';
import { State } from '../../../../store/state';

const AddToShopify: FunctionComponent = () => {
  const country = useSelector((state: State) => state.dashboard.merchantMe?.country);
  const isShopifyInstalled = useSelector((state: State) => state.dashboard.merchantMe?.hasShopifyReference);

  const isTabletMobile = useMediaQuery('(max-width:768px)');
  const hasTransparentIntegration = country === 'BR';

  const { testMode, onTestModeHandler } = useTestModeHandler();

  return (
    <div className="add-to-shopify">
      {!hasTransparentIntegration && (
        <ShopifyRedirect>
          <AddShopifyInstallButton size={`${isTabletMobile ? 'full-square' : 'square'}`} />
        </ShopifyRedirect>
      )}
      {hasTransparentIntegration && !isShopifyInstalled && (
        <ShopifyTransparent>
          <AddShopifyInstallButton size={`${isTabletMobile ? 'full-square' : 'square'}`} />
        </ShopifyTransparent>
      )}
      {hasTransparentIntegration && isShopifyInstalled && (
        <ShopifyTransparentInstalled testMode={testMode} onTestModeChange={onTestModeHandler} />
      )}
    </div>
  );
};

export default AddToShopify;
